import { Card } from "../components/ui/Card";
import { PageHeader } from "../components/ui/PageHeader";
import { useUiPreferences } from "../context/UiPreferencesContext";

export function Settings() {
  const { density, setDensity, exportFormat, setExportFormat } = useUiPreferences();

  return (
    <div className="page">
      <PageHeader
        eyebrow="Workspace"
        title="Settings"
        description="Preferences are saved in this browser (localStorage). Export uses the current timeframe and revenue filters from the header."
      />

      <div className="grid-2">
        <Card title="Appearance" subtitle="Tighter spacing across the dashboard">
          <label className="field-block">
            <span>Density</span>
            <select
              value={density}
              onChange={(e) => setDensity(e.target.value)}
            >
              <option value="comfortable">Comfortable</option>
              <option value="compact">Compact</option>
            </select>
          </label>
        </Card>
        <Card title="Exports" subtitle="Used by the Export button in the top bar">
          <label className="field-block">
            <span>Default format</span>
            <select
              value={exportFormat}
              onChange={(e) => setExportFormat(e.target.value)}
            >
              <option value="pdf">PDF (browser print / Save as PDF)</option>
              <option value="csv">CSV (submissions table)</option>
            </select>
          </label>
          <p className="muted small">
            CSV: downloads filtered submissions. PDF: opens the print dialog — choose “Save as PDF” in
            the printer list.
          </p>
        </Card>
      </div>
    </div>
  );
}
